export enum WebSocketMessageTypeOutgoing {
        WsDeviceUpdate,
        WsEspControlPower,
        WsEspControlReset,
        WsRequestTransputStates,
        WsRequestActiveNotifications,
        WsWebPortalUpdate
}
